module.exports = "https://dev.stanwinstonschool.com/lakeplacid_poster_alt Large.ec1e24d4d7a9b717f5a9a5698960ca50.jpeg";